/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */



AddModel({
	Name: "SleepsackLegbinder",
	Folder: "Sleepsack",
	TopLevel: true,
	Parent: "SleepsackJacket",
	Restraint: true,
	AddPose: ["EncaseTorsoLower"],
	Categories: ["Restraints", "Legbinder", "Sleepsack", "Pants"],
	Layers: ToLayerMap([
		{ Name: "LegLeft", Layer: "LegbinderLegsOver2", Pri: 30,
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			HideWhenOverridden: true,
			InheritColor: "Binder",
			AppendPose: {Saddled: "Saddled"}, NoAppendDisplacement: true,
			DisplaceAmount: 100,
			DisplaceLayers: ToMap(["Legbinder"]),
			DisplacementSprite: "LegbinderSquish",
			SwapLayerPose: {Saddled: "LegbinderLegLeftPants"},

		},
		{ Name: "LegLowerLeft", Layer: "LegbinderAnklesOver", Pri: 30,
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			SwapLayerPose: {Saddled: "LegbinderLegLeftLowerPants", Kneel: "LegbinderLegsOver", KneelClosed: "LegbinderLegsOver"},
			AppendPose: {Saddled: "Saddled"},
			InheritColor: "Binder",
		},
		{ Name: "LegRight", Layer: "LegbinderLegsOver2", Pri: 30,
			//SwapLayerPose: {Kneel: "WrappingLegsRightOver", KneelClosed: "WrappingLegsRightOver"},
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			TieToLayer: "LegLeft",
			AppendPose: {Saddled: "Saddled"},
			InheritColor: "Binder",
			SwapLayerPose: {Saddled: "LegbinderLegRightPants"},

		},
		{ Name: "LegLowerRight", Layer: "LegbinderAnklesOver", Pri: 30,
			SwapLayerPose: {Saddled: "LegbinderLegLowerRightPants", Kneel: "WrappingLegsRight", KneelClosed: "WrappingLegsRight"},
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			TieToLayer: "LegLowerLeft",
			AppendPose: {Saddled: "Saddled"},
			InheritColor: "Binder",

		},

		// belts
		{ Name: "InnerBG", Layer: "LegbinderBack", Pri: 30,
			Poses: ToMap(["Spread"]),
			Invariant: true,
			InheritColor: "BinderInner",
			NoOverride: true,
		},
		{ Name: "MetalBG", Layer: "LegbinderBack", Pri: 30.1,
			Poses: ToMap(["Spread"]),
			Invariant: true,
			InheritColor: "Hardware",
			NoOverride: true,
		},
		{ Name: "BeltBG1", Layer: "LegbinderBack", Pri: -30,
			Poses: ToMap(["Spread"]),
			Invariant: true,
			InheritColor: "Straps",
		},
		{ Name: "BeltBG2", Layer: "LegbinderBack", Pri: -30,
			Poses: ToMap(["Spread"]),
			Invariant: true,
			InheritColor: "Straps",
		},
		{ Name: "BeltBG3", Layer: "LegbinderBack", Pri: -30,
			Poses: ToMap(["Spread"]),
			Invariant: true,
			InheritColor: "Straps",
		},
		
		{ Name: "LegLeftBelts", Layer: "LegbinderLegsOver2", Pri: 30.1,
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			HideWhenOverridden: true,
			InheritColor: "Straps",
			TieToLayer: "LegLeft",
			HidePoses: {Saddled: true},
			NoOverride: true,

		},
		{ Name: "LegLowerLeftBelts", Layer: "LegbinderAnklesOver", Pri: 30.1,
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			SwapLayerPose: {Kneel: "LegbinderLegsOver", KneelClosed: "LegbinderLegsOver"},
			InheritColor: "Straps",
			TieToLayer: "LegLowerLeft",
			HidePoses: {Saddled: true},
			NoOverride: true,
		},
		{ Name: "LegRightBelts", Layer: "LegbinderLegsOver2", Pri: 30.1,
			//SwapLayerPose: {Kneel: "WrappingLegsRightOver", KneelClosed: "WrappingLegsRightOver"},
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Straps",
			TieToLayer: "LegLeft",
			HidePoses: {Saddled: true},
			NoOverride: true,

		},
		{ Name: "LegLowerRightBelts", Layer: "LegbinderAnklesOver", Pri: 30.1,
			SwapLayerPose: {Kneel: "WrappingLegsRight", KneelClosed: "WrappingLegsRight"},
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			InheritColor: "Straps",
			TieToLayer: "LegLowerLeft",
			HidePoses: {Saddled: true},
			NoOverride: true,

		},
		// hw
		
		{ Name: "LegLeftMetal", Layer: "LegbinderLegsOver2", Pri: 30.2,
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			HideWhenOverridden: true,
			InheritColor: "Hardware",
			TieToLayer: "LegLeft",
			AppendPose: {Saddled: "Saddled"}, 
			NoOverride: true,
			SwapLayerPose: {Saddled: "LegbinderLegLeftPants"},

		},
		{ Name: "LegLowerLeftMetal", Layer: "LegbinderAnklesOver", Pri: 30.2,
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			SwapLayerPose: {Saddled: "LegbinderLegLeftLowerPants", Kneel: "LegbinderLegsOver", KneelClosed: "LegbinderLegsOver"},
			InheritColor: "Hardware",
			TieToLayer: "LegLowerLeft",
			HidePoses: {Saddled: true},
			NoOverride: true,
		},
		{ Name: "LegRightMetal", Layer: "LegbinderLegsOver2", Pri: 30.2,
			//SwapLayerPose: {Kneel: "WrappingLegsRightOver", KneelClosed: "WrappingLegsRightOver"},
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Hardware",
			TieToLayer: "LegLeft",
			AppendPose: {Saddled: "Saddled"},
			SwapLayerPose: {Saddled: "LegbinderLegRightPants"},
			NoOverride: true,

		},
		{ Name: "LegLowerRightMetal", Layer: "LegbinderAnklesOver", Pri: 30.2,
			SwapLayerPose: {Saddled: "LegbinderLegLowerRightPants", Kneel: "WrappingLegsRight", KneelClosed: "WrappingLegsRight"},
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			InheritColor: "Hardware",
			TieToLayer: "LegLowerLeft",
			NoOverride: true,

		},
		// text
		
		{ Name: "LegLeftText", Layer: "LegbinderLegsOver2", Pri: 30.3,
			Poses: ToMap(LEGPOSES),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			HideWhenOverridden: true,
			InheritColor: "Text",
			HidePoses: {NoPrisonerMarkings: true},
			TieToLayer: "LegLeft",
			MorphPoses: {Flip: "Flip"},
			AppendPose: {Saddled: "Saddled"},
			NoOverride: true,
			SwapLayerPose: {Saddled: "LegbinderLegLeftPants"},

		},
	])
});



AddModel({
	Name: "SleepsackLegbinderFull",
	Folder: "Sleepsack",
	TopLevel: false,
	Restraint: true,
	Parent: "SleepsackLegbinderFull",
	Categories: ["Restraints", "Legbinder", "Sleepsack"],
	AddPose: ["EncaseTorsoLower"],
	HideLayerGroups: ["SlimeFeet", "BelowShoes", "Shoes"],
	Layers: ToLayerMap([
		...GetModelLayers("SleepsackLegbinder"),
		{ Name: "Feet", Layer: "LegbinderAnklesOver", Pri: 29,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			InheritColor: "Binder",
			EraseInvariant: true,
			EraseMorph: {Closed: "Closed"},
			EraseSprite: "HeelsRightErase",
			EraseAmount: 100,
			EraseLayers: ToMap(["LegbinderRight"]),
			EraseZBonus: 30000,
			SwapLayerPose: {Saddled: "LegbinderAnkleLeftPants"},
		},
		{ Name: "FeetBelts", Layer: "LegbinderAnklesOver", Pri: 29.2,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			TieToLayer: "Feet",
			InheritColor: "Straps",
			SwapLayerPose: {Saddled: "LegbinderAnkleLeftPants"},
		},
		{ Name: "FeetMetal", Layer: "LegbinderAnklesOver", Pri: 29.1,
			Poses: ToMap(["Closed"]),
			NoOverride: true,
			TieToLayer: "Feet",
			InheritColor: "Hardware",
			SwapLayerPose: {Saddled: "LegbinderAnkleLeftPants"},
		},
		{ Name: "FootLeft", Layer: "LegbinderAnklesOver", Pri: 31,
			Poses: ToMapSubtract(LEGPOSES, ["Closed"]),
			HideWhenOverridden: true,
			NoOverride: true,
			InheritColor: "Binder",
			SwapLayerPose: {Saddled: "LegbinderAnkleLeftPants"},
		},
		{ Name: "FootRight", Layer: "LegbinderAnklesOver", Pri: 31,
			Poses: ToMapSubtract(LEGPOSES, ["Closed"]),
			HideWhenOverridden: true,
			NoOverride: true,
			InheritColor: "Binder",
			SwapLayerPose: {Saddled: "LegbinderAnkleRightPants"},
		},
		{ Name: "FootLeftBelts", Layer: "LegbinderAnklesOver", Pri: 31,
			Poses: ToMapSubtract(LEGPOSES, ["Closed"]),
			HideWhenOverridden: true,
			NoOverride: true,
			TieToLayer: "FootLeft",
			InheritColor: "Straps",
			SwapLayerPose: {Saddled: "LegbinderAnkleLeftPants"},
		},
		{ Name: "FootRightBelts", Layer: "LegbinderAnklesOver", Pri: 31,
			Poses: ToMapSubtract(LEGPOSES, ["Closed"]),
			HideWhenOverridden: true,
			NoOverride: true,
			TieToLayer: "FootRight",
			InheritColor: "Straps",
			SwapLayerPose: {Saddled: "LegbinderAnkleRightPants"},
		},
		{ Name: "FootLeftMetal", Layer: "LegbinderAnklesOver", Pri: 31,
			Poses: ToMapSubtract(LEGPOSES, ["Closed"]),
			HideWhenOverridden: true,
			NoOverride: true,
			TieToLayer: "FootLeft",
			InheritColor: "Hardware",
			SwapLayerPose: {Saddled: "LegbinderAnkleLeftPants"},
		},
		{ Name: "FootRightMetal", Layer: "LegbinderAnklesOver", Pri: 31,
			Poses: ToMapSubtract(LEGPOSES, ["Closed"]),
			HideWhenOverridden: true,
			NoOverride: true,
			TieToLayer: "FootRight",
			InheritColor: "Hardware",
			SwapLayerPose: {Saddled: "LegbinderAnkleRightPants"},
		},
		

	])
});

AddModel(GetModelFashionVersion("SleepsackLegbinder", true));
AddModel(GetModelFashionVersion("SleepsackLegbinderFull", true));




AddModel({
	Name: "SleepsackJacket",
	Folder: "SleepsackJacket",
	Parent: "SleepsackJacket",
	TopLevel: false,
	Restraint: true,
	AddPose: ["EncaseArmLeft", "EncaseArmRight", "EncaseHandLeft", "EncaseHandRight", "EncaseTorsoUpper"],
	Categories: ["Restraints", "Jacket", "Leather", "Uniforms"],
	HideLayerGroups: ["Waistbelts"],
	Layers: ToLayerMap([

		{ Name: "Leather", Layer: "BulkyJacket", Pri: 140,
			Poses: ToMap(["Wristtie", "Boxtie", "Crossed", "Front", "Free", "Yoked", "Up"]),
			SwapLayerPose: {Crossed: "SleevesCrossArms"},
			GlobalDefaultOverride: ToMap(["Crossed", "Front"]),
			HidePoses: ToMap(["WrapArms"]),
			InheritColor: "Binder",
		},
		{ Name: "Belts", Layer: "BulkyJacket", Pri: 140.1,
			Poses: ToMap(["Wristtie", "Boxtie", "Crossed", "Front", "Free", "Yoked", "Up"]),
			SwapLayerPose: {Crossed: "SleevesCrossArms"},
			GlobalDefaultOverride: ToMap(["Crossed", "Front"]),
			HidePoses: ToMap(["WrapArms"]),
			InheritColor: "Straps",
			NoOverride: true,
			TieToLayer: "Leather",
		},
		{ Name: "Metal", Layer: "BulkyJacket", Pri: 140.2,
			Poses: ToMap(["Wristtie", "Boxtie", "Crossed", "Front", "Free", "Yoked", "Up"]),
			SwapLayerPose: {Crossed: "SleevesCrossArms"},
			GlobalDefaultOverride: ToMap(["Crossed", "Front"]),
			HidePoses: ToMap(["WrapArms"]),
			InheritColor: "Hardware",
			NoOverride: true,
			TieToLayer: "Leather",
		},
		{ Name: "ChestLeatherZipped", Layer: "ShirtChest", Pri: 140,
			Poses: ToMap([...ARMPOSES]),
			Invariant: true,
			HidePoses: ToMap(["WrapChest"]),
			DisplacementSprite: "Jacket",
			DisplaceAmount: 70,
			NoOverride: true,
			DisplaceLayers: ToMap(["ArmsAll"]),
			InheritColor: "Binder",
		},
		{ Name: "ChestBeltsZipped", Layer: "ShirtChest", Pri: 140.1,
			Poses: ToMap([...ARMPOSES]),
			Invariant: true,
			HidePoses: ToMap(["WrapChest"]),
			TieToLayer: "ChestLeatherZipped",
			InheritColor: "Straps",
			NoOverride: true,
		},
		{ Name: "ChestMetalZipped", Layer: "ShirtChest", Pri: 140.2,
			Poses: ToMap([...ARMPOSES]),
			Invariant: true,
			HidePoses: ToMap(["WrapChest"]),
			TieToLayer: "ChestLeatherZipped",
			InheritColor: "Hardware",
			NoOverride: true,
		},
		{ Name: "ChestTextZipped", Layer: "ShirtChest", Pri: 140.3,
			Poses: ToMap([...ARMPOSES]),
			Invariant: true,
			HidePoses: ToMap(["WrapChest", "NoPrisonerMarkings"]),
			TieToLayer: "ChestLeatherZipped",
			InheritColor: "Text",
			MorphPoses: {Flip: "Flip"},
			NoOverride: true,
		},


		{ Name: "ArmLeatherLeft", Layer: "SleeveLeft", Pri: 140,
			Poses: ToMap(["Yoked", "Front", "Free", "Up"]),
			SwapLayerPose: {Crossed: "SleevesCrossArms"},
			HidePoses: ToMap(["WrapArms"]),
			InheritColor: "Binder",
		},
		{ Name: "ArmLeatherRight", Layer: "SleeveRight", Pri: 140,
			Poses: ToMap(["Boxtie", "Front", "Yoked", "Free", "Up"]),
			SwapLayerPose: {Crossed: "SleevesCrossArms"},
			HidePoses: ToMap(["WrapArms"]),
			InheritColor: "Binder",
		},
		{ Name: "ArmBeltsLeft", Layer: "BindArmLeft", Pri: 140.1,
			NoOverride: true,
			Poses: ToMap(["Yoked", "Front", "Free", "Up"]),
			SwapLayerPose: {Crossed: "BindCrossArms"},
			InheritColor: "Straps",
		},
		{ Name: "ArmBeltsRight", Layer: "BindArmRight", Pri: 140.1,
			NoOverride: true,
			Poses: ToMap(["Boxtie", "Front", "Yoked", "Free", "Up"]),
			SwapLayerPose: {Crossed: "BindCrossArms"},
			InheritColor: "Straps",
		},
		{ Name: "ArmMetalLeft", Layer: "BindArmLeft", Pri: 140.2,
			NoOverride: true,
			Poses: ToMap(["Yoked", "Front", "Free", "Up"]),
			SwapLayerPose: {Crossed: "BindCrossArms"},
			InheritColor: "Hardware",
		},
		{ Name: "ArmMetalRight", Layer: "BindArmRight", Pri: 140.2,
			NoOverride: true,
			Poses: ToMap(["Boxtie", "Front", "Yoked", "Free", "Up"]),
			SwapLayerPose: {Crossed: "BindCrossArms"},
			InheritColor: "Hardware",
		},

		{ Name: "ForeArmLeatherLeft", Layer: "ForeSleeveLeft", Pri: 140,
			Poses: ToMap(["Front"]),
			GlobalDefaultOverride: ToMap(["Front"]),
			HidePoses: ToMap(["WrapArms"]),
			InheritColor: "Binder",
		},
		{ Name: "ForeArmLeatherRight", Layer: "ForeSleeveRight", Pri: 140,
			Poses: ToMap(["Front"]),
			GlobalDefaultOverride: ToMap(["Front"]),
			HidePoses: ToMap(["WrapArms"]),
			InheritColor: "Binder",
		},
		{ Name: "ForeArmBeltsLeft", Layer: "BindForeArmLeft", Pri: 140.1,
			NoOverride: true,
			Poses: ToMap(["Front"]),
			GlobalDefaultOverride: ToMap(["Front"]),
			InheritColor: "Straps",
		},
		{ Name: "ForeArmBeltsRight", Layer: "BindForeArmRight", Pri: 140.1,
			NoOverride: true,
			Poses: ToMap(["Front"]),
			GlobalDefaultOverride: ToMap(["Front"]),
			InheritColor: "Straps",
		},
		{ Name: "ForeArmMetalLeft", Layer: "BindForeArmLeft", Pri: 140.2,
			NoOverride: true,
			Poses: ToMap(["Front"]),
			GlobalDefaultOverride: ToMap(["Front"]),
			InheritColor: "Hardware",
		},
		{ Name: "ForeArmMetalRight", Layer: "BindForeArmRight", Pri: 140.2,
			NoOverride: true,
			Poses: ToMap(["Front"]),
			GlobalDefaultOverride: ToMap(["Front"]),
			InheritColor: "Hardware",
		},

		{ Name: "HandLeatherLeft", Layer: "BindHandLeft", Pri: 30,
			Poses: ToMap(["Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			InheritColor: "MittenLeft",
			EraseSprite: "MittL",
			EraseLayers: ToMap(["MittL"]),
		},
		{ Name: "HandLeatherRight", Layer: "BindHandRight", Pri: 30,
			Poses: ToMap(["Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			EraseSprite: "MittR",
			InheritColor: "MittenRight",
			EraseLayers: ToMap(["MittR"]),
		},
		
		{ Name: "ForeHandLeatherLeft", Layer: "BindForeHandLeft", Pri: 30,
			Poses: ToMap(["Front", "Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			SwapLayerPose: {Crossed: "CrossGloveLeft"},
			EraseSprite: "MittL",
			EraseLayers: ToMap(["MittL"]),
			InheritColor: "MittenLeft",
		},
		{ Name: "ForeHandLeatherRight", Layer: "BindForeHandRight", Pri: 30,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "MittenRight",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
			EraseSprite: "MittR",
			EraseLayers: ToMap(["MittR"]),
		},




		
		{ Name: "HandBeltsLeft", Layer: "BindHandLeft", Pri: 30.1,
			Poses: ToMap(["Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			InheritColor: "Straps",
		},
		{ Name: "HandBeltsRight", Layer: "BindHandRight", Pri: 30.1,
			Poses: ToMap(["Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			InheritColor: "Straps",
		},
		
		{ Name: "ForeHandBeltsLeft", Layer: "BindForeHandLeft", Pri: 30.1,
			Poses: ToMap(["Front", "Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			SwapLayerPose: {Crossed: "CrossGloveLeft"},
			InheritColor: "Straps",
		},
		{ Name: "ForeHandBeltsRight", Layer: "BindForeHandRight", Pri: 30.1,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Straps",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
		},

		

		
		{ Name: "HandMetalLeft", Layer: "BindHandLeft", Pri: 30.2,
			Poses: ToMap(["Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			InheritColor: "Hardware",
		},
		{ Name: "HandMetalRight", Layer: "BindHandRight", Pri: 30.2,
			Poses: ToMap(["Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			InheritColor: "Hardware",
		},
		
		{ Name: "ForeHandMetalLeft", Layer: "BindForeHandLeft", Pri: 30.2,
			Poses: ToMap(["Front", "Yoked", "Free"]),
			GlobalDefaultOverride: ToMap(["Front", "Yoked", "Free"]),
			SwapLayerPose: {Crossed: "CrossGloveLeft"},
			InheritColor: "Hardware",
		},
		{ Name: "ForeHandMetalRight", Layer: "BindForeHandRight", Pri: 30.2,
			Poses: ToMap([...FOREARMPOSES]),
			InheritColor: "Hardware",
			GlobalDefaultOverride: ToMap(["Front", "Crossed"]),
			SwapLayerPose: {Crossed: "CrossGloveRight"},
		},
	])
});


AddModel(GetModelFashionVersion("SleepsackJacket", true));


AddModel({
	Name: "PlasmaMuzzle",
	Folder: "Sleepsack",
	TopLevel: true,
	Group: "Mouth",
	Restraint: true,
	Categories: ["Restraints","Gags"],
	AddPose: ["FaceCoverGag", "StuffMouth"],
	Layers: ToLayerMap([
		{ Name: "PanelLeather", Layer: "GagMuzzle", Pri: 5,
			Invariant: true,
			InheritColor: "Panel",
			HideWhenOverridden: true,
			DisplacementSources: ["Head", "FaceGag"],
		},
		{ Name: "MuzzleLeather", Layer: "GagMuzzleStraps", Pri: 19,
			Invariant: true,
			InheritColor: "Leather",
		},
		{ Name: "MuzzleMetal", Layer: "GagMuzzleStraps", Pri: 19.2,
			Invariant: true,
			InheritColor: "Hardware",
			TieToLayer: "MuzzleLeather", NoOverride: true,
		},
		{ Name: "MuzzleStitching", Layer: "GagMuzzleStraps", Pri: 19.1,
			Invariant: true,
			InheritColor: "PanelStitching",
			TieToLayer: "PanelLeather",
			NoOverride: true,
		},
		{ Name: "HarnessLeather", Layer: "GagMuzzleStraps", Pri: 21,
			Invariant: true,
			InheritColor: "Leather",
			HideWhenOverridden: true,
		},
		{ Name: "HarnessMetal", Layer: "GagMuzzleStraps", Pri: 21.2,
			Invariant: true,
			InheritColor: "Hardware",
			TieToLayer: "HarnessLeather", NoOverride: true,
		},
		{ Name: "HarnessStitching", Layer: "GagMuzzleStraps", Pri: 21.1,
			Invariant: true,
			InheritColor: "Stitching",
			TieToLayer: "HarnessLeather", NoOverride: true,
		},
		{ Name: "LocksMetal", Layer: "GagMuzzleStraps", Pri: 21.3,
			Invariant: true,
			LockLayer: true,
			InheritColor: "LocksShackle",
			TieToLayer: "HarnessLeather", NoOverride: true,
		},
		{ Name: "LocksPadlock", Layer: "GagMuzzleStraps", Pri: 21.4,
			Invariant: true,
			LockLayer: true,
			InheritColor: "Locks",
			TieToLayer: "HarnessLeather", NoOverride: true,
		},
	])
});

AddModel(GetModelFashionVersion("PlasmaMuzzle", true));



AddModel({
	Name: "SleepsackSuspend",
	Folder: "SleepsackJacket",
	Parent: "Sleepsack",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "Leather", "Suspension"],
	AddPose: ["Suspended"],
	HideLayerGroups: ["Waistbelts"],
	Layers: ToLayerMap([
		{ Name: "Suspension", Layer: "FurnitureBack", Pri: 10,
			Invariant: true,
			InheritColor: "Straps",
			NoOverride: true,
		},
	])
});